import { render, staticRenderFns } from "./WCompanySurveys.vue?vue&type=template&id=dd6f9298&"
import script from "./WCompanySurveys.vue?vue&type=script&lang=ts&"
export * from "./WCompanySurveys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports